var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.percentage > 0)?_c('div',[_c('b-progress',{attrs:{"value":_vm.percentage,"height":".2rem","max":"1","variant":_vm.colour}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }